var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 11.273,
    viewBox: "0 0 14 11.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Show",
    "data-name": "Iconly/Light-Outline/Show",
    transform: "translate(-2 -4.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Show",
    transform: "translate(2 4.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M7,0C9.9,0,12.5,2.032,13.957,5.43a.52.52,0,0,1,0,.414C12.5,9.242,9.9,11.272,7,11.274H7c-2.9,0-5.495-2.031-6.955-5.43a.526.526,0,0,1,0-.414C1.5,2.032,4.1,0,7,0ZM7,1.05c-2.405,0-4.6,1.711-5.9,4.586,1.3,2.876,3.5,4.586,5.9,4.587s4.6-1.711,5.9-4.587C11.6,2.761,9.406,1.051,7,1.05ZM7,2.9A2.738,2.738,0,1,1,4.262,5.637,2.742,2.742,0,0,1,7,2.9Zm0,1.05A1.688,1.688,0,1,0,8.688,5.637,1.69,1.69,0,0,0,7,3.949Z",
    transform: "translate(0 -0.001)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.f30c4a5f38f23e71eafc76b3cc30eaaf.svg";
export { ForwardRef as ReactComponent };